var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlinedArrowRighTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31964_6167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59282 12.7295L11.4782 5.87484L10.32 14.0745C10.302 14.2062 10.4544 14.289 10.5541 14.2023L11.7468 13.1655C11.7994 13.1198 11.8329 13.0576 11.8426 12.9899L13.0941 4.14361C13.1056 4.06263 13.0996 3.98012 13.0764 3.90168C13.0532 3.82323 13.0135 3.75069 12.9598 3.68896C12.9061 3.62723 12.8398 3.57776 12.7654 3.54389C12.6909 3.51002 12.6101 3.49255 12.5283 3.49267L3.5408 3.49962C3.50535 3.49967 3.47289 3.51133 3.44729 3.53359L2.21415 4.60554C2.11442 4.69223 2.17638 4.85605 2.30808 4.85514L10.5878 4.85059L2.70246 11.7052C2.64316 11.7568 2.63682 11.8475 2.68837 11.9068L3.39129 12.7154C3.44283 12.7747 3.53353 12.781 3.59282 12.7295Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31964_6167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedArrowRighTop);
export default __webpack_public_path__ + "static/media/OutlinedArrowRighTop.727254cad4cb5d852d04bcb29ac23c80.svg";
export { ForwardRef as ReactComponent };